import { defaultNfpa } from "./state";

/**
 * Mutación que carga las opciones del select de la sección roja del rombo.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} optrojo contiene la información del select rojo del rombo.
 */
export function cargarColores(state, colores) {
    colores.forEach(element => {
        if ((state.optrojo.length != 5)) {
            state.optrojo.push({
                value: element.value,
                text: element.text
            })
        }
        if ((state.optazul.length != 5)) {
            state.optazul.push({
                value: element.value,
                text: element.text
            })
        }
        if ((state.optamarillo.length != 5)) {
            state.optamarillo.push({
                value: element.value,
                text: element.text
            })
        }
    });
}

/**
 * Mutación para limpiar el formulario de nfpa
 *
 * @export
 * @param {*} state contiene la informacion de variables del formulario.
 */
export function setDefaultNfpa(state) {
    Object.assign(state.selectedNfpa, defaultNfpa());
}

/**
 * Mutación que carga las opciones del select de la sección roja del rombo.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} optrojo contiene la información del select rojo del rombo.
 */
export function cargarOptRojo(state, optrojo) {

    state.optrojo = [];

    for (var i = 0; i < optrojo.length; i++) {
        state.optrojo.push({ value: optrojo[i].id, text: optrojo[i].lista });
    }
}

/**
 * Mutación que carga las opciones del select de la sección azul del rombo.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} optazul contiene la información del select azul del rombo.
 */
export function cargarOptAzul(state, optazul) {

    state.optazul = [];

    for (var i = 0; i < optazul.length; i++) {
        state.optazul.push({ value: optazul[i].id, text: optazul[i].lista });
    }
}

/**
 * Mutación que carga las opciones del select de la sección amarilla del rombo.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} optamarillo contiene la información del select amarillo del rombo.
 */
export function cargarOptAmarillo(state, optamarillo) {

    state.optamarillo = [];

    for (var i = 0; i < optamarillo.length; i++) {
        state.optamarillo.push({ value: optamarillo[i].id, text: optamarillo[i].lista });
    }
}

/**
 * Mutación que carga las opciones del select de la sección blanca del rombo.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} optblanco contiene la información del select blanca del rombo.
 */
export function cargarOptBlanco(state, optblanco) {

    state.optblanco = [];

    for (var i = 0; i < optblanco.length; i++) {
        state.optblanco.push({ value: optblanco[i].id, text: optblanco[i].lista });
    }
}

/**
 * Mutación que carga la información de NFPA del producto quimico al formulario.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} nfpa contien la información de nfpa del producto quimico.
 * @param {*} admin indica si es admin o no.
 */
export function setNfpa(state, nfpa) {

    state.selectedNfpa = nfpa;

}
